import { FunctionComponent, useCallback, useEffect } from 'react'
import { useDropdownContext } from '../Dropdown/DropdownContext'
import useStyles from './styles'
import { OptionProps } from './types'

export const Option: FunctionComponent<OptionProps> = ({
  label,
  value,
  styles: overrides,
  ...props
}) => {
  const styles = useStyles()
  const { registerLabel, onChange } = useDropdownContext() || {}

  if (!registerLabel) {
    throw new Error('Option: Missing DropdownContext')
  }

  useEffect(() => {
    registerLabel && registerLabel({ value, label })
  }, [value, label, registerLabel])

  const handleClick = useCallback(() => {
    onChange && onChange(value)
  }, [value, onChange])

  return (
    <button
      css={[styles.root, overrides?.root]}
      value={value}
      onClick={handleClick}
      {...props}
    >
      <span css={[styles.label, overrides?.label]}>{label || value}</span>
    </button>
  )
}
